export function formatNumber(value: unknown): string {
  const number = Number(value || 0);
  return Number.isFinite(number) ? new Intl.NumberFormat("ko-KR").format(number) : "0";
}

export function formatMoney(value: unknown): string {
  const number = Number(value || 0);
  return Number.isFinite(number) ? `${new Intl.NumberFormat("ko-KR").format(number)}원` : "0원";
}

export function formatDateTime(value: unknown): string {
  if (!value) return "-";
  const date = new Date(String(value));
  if (Number.isNaN(date.getTime())) return "-";
  const parts = new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).formatToParts(date).reduce<Record<string, string>>((acc, part) => {
    if (part.type !== "literal") acc[part.type] = part.value;
    return acc;
  }, {});
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}

export function normalizeText(value: unknown): string {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
}

export function compactLabel(value: unknown, fallback = "-"): string {
  const text = String(value || "").trim();
  return text || fallback;
}

export function formatSizeLabel(value: unknown, fallback = "-"): string {
  const text = String(value || "").trim();
  return text ? text.toUpperCase() : fallback;
}
